import _typeof from "D:/VUE\u5EB7\u4E50\u901A\u95E8\u5E97/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.object.keys.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
import { TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import { ref, watchEffect } from "../../adapter-vue";
import { isPC, isUniFrameWork } from "../../utils/env";
import { TUIGlobal } from "../../utils/universal-api/index";
import SelectFriend from "./select-friend/index.vue";
import ContactSearch from "./contact-search/index.vue";
import ContactList from "./contact-list/index.vue";
import ContactInfo from "./contact-info/index.vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    // web/h5 单页面应用展示形式，uniapp 请忽略
    displayType: {
      type: String,
      "default": "contactList",
      require: false
    }
  },
  emits: ["switchConversation"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var props = __props;
    var displayTypeRef = ref(props.displayType || "contactList");
    var isShowSelectFriend = ref(false);
    var isShowContactList = ref(true);
    var isShowContactListInH5 = ref(true);
    var isShowContactInfoInH5 = ref(true);
    watchEffect(function () {
      isShowContactList.value = (props === null || props === void 0 ? void 0 : props.displayType) !== "selectFriend";
    });
    TUIStore.watch(StoreName.CUSTOM, {
      isShowSelectFriendComponent: function isShowSelectFriendComponent(data) {
        if (!isUniFrameWork && (props === null || props === void 0 ? void 0 : props.displayType) === "selectFriend") {
          // 原生 web & h5 单页面应用，displayType 为 selectFriend 时，才唤起 selectFriend
          isShowSelectFriend.value = data;
          isShowContactList.value = false;
          return;
        }
        if (data) {
          isShowSelectFriend.value = true;
          if (isUniFrameWork) {
            displayTypeRef.value = "selectFriend";
            TUIGlobal === null || TUIGlobal === void 0 || TUIGlobal.hideTabBar();
          }
        } else {
          isShowSelectFriend.value = false;
          if (isUniFrameWork) {
            displayTypeRef.value = props.displayType;
            TUIGlobal === null || TUIGlobal === void 0 || TUIGlobal.showTabBar();
          }
        }
      },
      currentContactInfo: function currentContactInfo(data) {
        var _Object$keys;
        if (isPC) {
          isShowContactListInH5.value = true;
          isShowContactInfoInH5.value = true;
        } else if (!data || _typeof(data) !== "object" || ((_Object$keys = Object.keys(data)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) <= 0) {
          // 判断 移动端 展示 contactList 还是 contactInfo
          // contactInfo 不存在，展示contactList
          isShowContactListInH5.value = true;
          isShowContactInfoInH5.value = false;
        } else {
          // 判断 移动端 展示 contactList 还是 contactInfo
          // contactInfo 存在，展示contactInfo
          isShowContactListInH5.value = false;
          isShowContactInfoInH5.value = true;
        }
      }
    });
    var switchConversation = function switchConversation(data) {
      isUniFrameWork && (TUIGlobal === null || TUIGlobal === void 0 ? void 0 : TUIGlobal.navigateTo({
        url: "/TUIKit/components/TUIChat/index"
      }));
      emits("switchConversation", data);
    };
    return function (_ctx, _cache) {
      return _unref(isShowSelectFriend) ? (_openBlock(), _createBlock(SelectFriend, {
        key: 0
      })) : _unref(isShowContactList) ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        "class": _normalizeClass(['TUI-contact', !_unref(isPC) && 'TUI-contact-h5'])
      }, [_unref(isShowContactListInH5) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": _normalizeClass(['TUI-contact-left', !_unref(isPC) && 'TUI-contact-h5-left'])
      }, [_createVNode(ContactSearch), _createVNode(ContactList, {
        "class": _normalizeClass(['TUI-contact-left-list', !_unref(isPC) && 'TUI-contact-h5-left-list'])
      }, null, 8, ["class"])], 2)) : _createCommentVNode("", true), _unref(isShowContactInfoInH5) ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        "class": _normalizeClass(['TUI-contact-right', !_unref(isPC) && 'TUI-contact-h5-right'])
      }, [_createVNode(ContactInfo, {
        onSwitchConversation: switchConversation
      })], 2)) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true);
    };
  }
});